import { FilterEqOperation } from '../types/types';
import _ from 'lodash';
var ColorFilterModel = /** @class */ (function () {
    function ColorFilterModel(filterType, title, options, field) {
        this.filterType = filterType;
        this.field = field;
        this.title = title;
        this.options = this.toColorOptions(options);
        this.selectedOptionIds = [];
    }
    ColorFilterModel.prototype.update = function (optionId) {
        if (this.selectedOptionIds.indexOf(optionId) === -1) {
            this.selectedOptionIds.push(optionId);
        }
        else {
            var index = this.selectedOptionIds.indexOf(optionId);
            this.selectedOptionIds.splice(index, 1);
        }
    };
    ColorFilterModel.prototype.toDTO = function () {
        var _this = this;
        var hexColors = [];
        this.selectedOptionIds.forEach(function (selectedOptionId) {
            var hexColor = _this.convertRgbToHex(selectedOptionId);
            /* istanbul ignore next: todo(daniela): test this */
            if (hexColor !== selectedOptionId) {
                hexColors.push(hexColor);
            }
            var shortHex = _this.hexToShortHex(hexColor);
            /* istanbul ignore next: todo(daniela): test this */
            if (shortHex !== hexColor) {
                hexColors.push(shortHex);
            }
        });
        return {
            field: this.field,
            op: FilterEqOperation.IN,
            values: this.selectedOptionIds.concat(hexColors),
        };
    };
    ColorFilterModel.prototype.hasSelectedOptions = function () {
        return !!this.selectedOptionIds.length;
    };
    ColorFilterModel.prototype.reset = function () {
        this.selectedOptionIds = [];
    };
    ColorFilterModel.prototype.toColorOptions = function (filterOptions) {
        var _this = this;
        return _.uniqBy(filterOptions.map(function (filterOption) {
            return {
                rgbValue: _this.convertToRgb(filterOption.key),
                name: filterOption.value,
            };
        }), 'rgbValue');
    };
    ColorFilterModel.prototype.convertRgbToHex = function (rgbValue) {
        var digits = /(.*?)rgb\((\d+), (\d+), (\d+)\)/.exec(rgbValue);
        /* istanbul ignore else: todo(daniela): test this */
        if (digits) {
            var red = parseInt(digits[2], 10);
            var green = parseInt(digits[3], 10);
            var blue = parseInt(digits[4], 10);
            return ("#" + this.componentToHex(red) + this.componentToHex(green) + this.componentToHex(blue)).toLowerCase();
        }
        else {
            return rgbValue;
        }
    };
    ColorFilterModel.prototype.convertToRgb = function (colorValue) {
        var result = colorValue;
        var colorRegexRes;
        if (colorValue.length === 7) {
            colorRegexRes = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorValue);
            /* istanbul ignore next: todo(daniela): test this */
            result = colorRegexRes
                ? "rgb(" + parseInt(colorRegexRes[1], 16) + ", " + parseInt(colorRegexRes[2], 16) + ", " + parseInt(colorRegexRes[3], 16) + ")"
                : colorValue;
        }
        else if (colorValue.length === 4) {
            colorRegexRes = /^#?([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})$/i.exec(colorValue);
            /* istanbul ignore next: todo(daniela): test this */
            result = colorRegexRes
                ? "rgb(" + parseInt(colorRegexRes[1] + colorRegexRes[1], 16) + ", " + parseInt(colorRegexRes[2] + colorRegexRes[2], 16) + ", " + parseInt(colorRegexRes[3] + colorRegexRes[3], 16) + ")"
                : colorValue;
        }
        return result;
    };
    ColorFilterModel.prototype.componentToHex = function (c) {
        var hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    };
    ColorFilterModel.prototype.hexToShortHex = function (hexValue) {
        var shortHex = hexValue;
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexValue);
        /* istanbul ignore else: todo(daniela): test this */
        if (result && result[1][0] === result[1][1] && result[2][0] === result[2][1] && result[3][0] === result[3][1]) {
            shortHex = "#" + result[1][0] + result[2][0] + result[3][0];
        }
        return shortHex;
    };
    return ColorFilterModel;
}());
export { ColorFilterModel };
//# sourceMappingURL=colorFilterModel.js.map